var rtl_rtlignore_default = {
  "rtl": "pT6R8",
  "ltr": "wSRQ2"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
